import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import YouTubeVideo from "./YouTubeVideo";
const images = require.context("../assets/images", false);

const videos = [
  { id: 1, url: "https://www.youtube.com/embed/1r9rRk2xpSI?feature=oembed" },
  { id: 2, url: "https://www.youtube.com/embed/5aWIB589zOo?feature=oembed" },
  { id: 3, url: "https://www.youtube.com/embed/F90cOsjw0lU?feature=oembed" },
  { id: 4, url: "https://www.youtube.com/embed/h7Wj1cMSEjk?feature=oembed" },
  { id: 5, url: "https://www.youtube.com/embed/ocvwsnkA39I?feature=oembed" },
    { id: 6, url: "https://www.youtube.com/embed/Nqgfn-tdxpo?feature=oembed" },
  { id: 7, url: "https://www.youtube.com/embed/P0LT3RPppuw?si=6rmDRqC6rPQEGqJE" }
];

const NextArrow = ({ onClick }) => (
  <button className="custom-next" onClick={onClick}>
    <img src={images("./Forward.svg")} alt="next" />
  </button>
);

const PrevArrow = ({ onClick }) => (
  <button className="custom-prev" onClick={onClick}>
    <img src={images("./backward.svg")} alt="prev" />
  </button>
);

function VideoSection() {
const [slidesToShow, setSlidesToShow] = useState(3);

  useEffect(() => {
    const updateSlides = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setSlidesToShow(1);
      } else if (width < 992) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(4);
      }
    };

    updateSlides(); // run immediately

    window.addEventListener("resize", updateSlides);
    return () => window.removeEventListener("resize", updateSlides);
  }, []);

const settings = {
  dots: true,
  infinite: true,
  slidesToShow: slidesToShow,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2500,
  speed: 500,
  arrows: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />
};



  return (
   <div className="video mt-80">
  <div className="container">
    <div className="heading center">
      <h2>Video Reviews</h2>
    </div>
   <div className="testimonials-slider-main">
    <Slider {...settings} className="video-slider">
        {videos.map((video) => (
          <div key={video.id}>
            <div className="video-slider-card">
              <YouTubeVideo
                src={video.url}
                title={`video-${video.id}`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        ))}
      </Slider>
    </div>
   
  </div>
</div>

  );
}

export default VideoSection;
